
window.getCookie = function(name) {
  match = document.cookie.match(new RegExp(name + '=([^;]+)'));
  if (match) return match[1];
}

let trustPilotScore;

// **************************
// LP SAMPLE CTA BUTTON CLICK
// **************************

var ctaClicked;
function sampleButton(button) { // called from page buttons...
  button.blur();
  $('#checkout_shipping_address_first_name_1').focus();
  if (ctaClicked) return;
  ctaClicked = true;
}


// ***********************
// GA EVENTS - FORM SUBMIT
// ***********************

var trackedForm = false;
var redirectData = { url: '', screen: '' };
function sampleLandingFormSuccess(order, screen) { // called from forms...
  if (trackedForm) return;
  trackedForm = true;
  redirectData.url = order.order_status_url + '#thank_you';
  redirectData.screen = screen;
  sampleThankYouOpen(redirectData.url, redirectData.screen);
  return;
  // trackLandingFormSubmit(order);
}
// function trackLandingFormSubmit(order) {
//   console.log("TRACK FORM");
//   const gaPromise = new Promise((resolve, reject) => {
//     ga('send', 'event', {
//       'eventCategory': 'SampleLanding Conversion', //required
//       'eventAction': 'Form Submit', //required
//       'eventLabel': screen.width+'x'+screen.height,
//       'eventValue': 0,
//       'hitCallback': function() {
//         console.log('SL-GA data sent.');
//         resolve();
//       },
//       'hitCallbackFail' : function () {
//         console.log("SL-GA Unable to send data.");
//         reject();
//       }
//     });
//   });
//   const gaOptPromise = new Promise((resolve, reject) => {
//     ga('opttags.send', 'event', {
//       'eventCategory': 'SampleLanding Conversion', //required
//       'eventAction': 'Form Submit', //required
//       'eventLabel': screen.width+'x'+screen.height,
//       'eventValue': 0,
//       'hitCallback': function() {
//         console.log('SL-GAO data sent.');
//         resolve();
//       },
//       'hitCallbackFail' : function () {
//         console.log("SL-GAO Unable to send data.");
//         reject();
//       }
//     });
//   });
//   const gtagPromise = new Promise((resolve, reject) => {
//     gtag('event', 'sample_conversion', {
//       'event_callback': function(id) {
//         console.log("SL-GA4 data sent. (" + id +")");
//         resolve();
//       },
//       'send_to':'G-376YHVQZ5M',
//       "transaction_id": order.name,
//       "affiliation": "Google online store",
//       "value": order.total_price,
//       "currency": order.currency,
//       "tax": order.total_tax,
//       "shipping": order.shipping_lines.map(s => parseFloat(s.price)).reduce((a, b) => a + b, 0).toFixed(2),
//       "items": order.line_items.map(li => ({  
//         "item_id": li.product_id,
//         "item_name": li.title,
//         "list_name": "",
//         "brand": "",
//         "category": "",
//         "item_variant": li.variant_id,
//         "list_position":'' ,
//         "quantity": li.quantity,
//         "price": li.price
//       }))
//     });
//     setTimeout(() => {
//       if (typeof reject === 'function') reject();
//     }, 2500);
//   });
//   Promise.all([gaPromise, gaOptPromise, gtagPromise]).then(success => {
//     console.log("SL-Data Success.");
//     sampleThankYouOpen(redirectData.url, redirectData.screen);
//   }).catch(error => {
//     console.log("SL-Data Error.");
//     sampleThankYouOpen(redirectData.url, redirectData.screen);
//   });
// }

// ****************
// TRUST PILOT DATA
// ****************
function getTrustPilotData() {
  $.ajax({
    "url": "https://api2.rmdy-brands.link/services/api/shopify/riv/trust_pilot?action=overall",
    "headers": { "x-api-key": "02Hd6xE1um4HeWG34qY4z9j3z59z2sGZ71AfujEd" },
    "method": "GET"
  })
  .done(function (res) {
    trustPilotScore = {
      numberOfReviews: res.overall.numberOfReviews,
      trustScore: res.overall.trustScore
    }
    $(".tp_reviews").html(res.overall.numberOfReviews)
    $(".tp_score").html(res.overall.trustScore)
  })
  .fail(function(e) {
    console.log('getTrustPilotData() fail', e)
  })
}
getTrustPilotData();

// REMOVE DEAL OF THE DAY POPUP FROM LPs
$('.deal-of-the-day-wrapper').remove();





